import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, X, Phone, Mail, MessageCircle } from 'lucide-react';
import { useSubscriptionWarning } from '../Hooks/useSubscriptionWarning';

/**
 * Component hiển thị cảnh báo thời hạn sử dụng
 * Hiển thị khi thời hạn sử dụng còn dưới 3 ngày
 */
const SubscriptionWarning = ({ sidebarWidth = 240 }) => {
  const { t } = useTranslation('subscription');
  const {
    showWarning,
    daysRemaining,
    isVisible,
    handleClose,
    handleContact,
    handleCall,
    handleZalo
  } = useSubscriptionWarning();

  if (!showWarning || !isVisible) {
    return null;
  }

  const getWarningColor = () => {
    if (daysRemaining <= 1) return 'bg-red-50 border-red-200 text-red-800';
    if (daysRemaining <= 3) return 'bg-orange-50 border-orange-200 text-orange-800';
    return 'bg-yellow-50 border-yellow-200 text-yellow-800';
  };

  const getWarningIcon = () => {
    if (daysRemaining <= 1) return 'text-red-600';
    if (daysRemaining <= 3) return 'text-orange-600';
    return 'text-yellow-600';
  };

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 p-4 border-b ${getWarningColor()}`} style={{ marginLeft: `${sidebarWidth}px` }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertTriangle className={`w-5 h-5 ${getWarningIcon()}`} />
            <div className="flex-1">
              <div className="font-medium">
                {daysRemaining === 0 
                  ? t("expires_today")
                  : daysRemaining === 1
                  ? t("expires_tomorrow")
                  : t("expires_in_days", { days: daysRemaining })
                }
              </div>
              <div className="text-sm opacity-90 mt-1">
                {t("contact_to_renew")}
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            {/* Contact buttons */}
            <button
              onClick={handleContact}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
            >
              <Mail className="w-4 h-4" />
              {t("contact_email")}
            </button>
            
            <button
              onClick={handleCall}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
            >
              <Phone className="w-4 h-4" />
              {t("contact_call")}
            </button>
            
            <button
              onClick={handleZalo}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              {t("contact_zalo")}
            </button>
            
            {/* Close button */}
            <button
              onClick={handleClose}
              className="p-1.5 rounded-lg hover:bg-white/20 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionWarning.propTypes = {
  sidebarWidth: PropTypes.number
};

export default SubscriptionWarning; 